module.exports = __webpack_public_path__ + "img/babymam.e54b05ef.png";